import { getConsent, loadGtag, trackPageview } from "./src/util/gtag"

// Load analytics on first entry only if the visitor previously accepted.
export const onClientEntry = () => {
    if (getConsent() === "granted") {
        loadGtag()
    }
}

// Track page views on client-side route changes (and initial load).
export const onRouteUpdate = ({ location }) => {
    if (getConsent() === "granted") {
        trackPageview(location.pathname + location.search)
    }
}
